import { type FC, type MouseEventHandler } from 'react';
import classnames from 'classnames';

import { SeoLink } from 'dibs-elements/exports/SeoLink.tsx';

import { PdpSharedFeedCarouselViewAllLabel } from './PdpSharedFeedCarouselFrame.tsx';

import dibsCss from 'dibs-css';
import styles from './PdpSharedFeedCarouselFrame.module.css';

export const PdpSharedFeedCarouselViewAllTile: FC<{
    href: string;
    onClick?: MouseEventHandler;
    target?: string;
    dataTn?: string;
}> = ({ href, onClick, target, dataTn }) => {
    return (
        <div className={classnames(dibsCss.selfStart, dibsCss.boxBorder, styles.viewAllTile)}>
            <SeoLink
                buyerLinkType="standardLinkNoUnderline"
                className={classnames(
                    dibsCss.flex,
                    dibsCss.itemsCenter,
                    dibsCss.justifyCenter,
                    dibsCss.boxBorder,
                    dibsCss.wFull,
                    dibsCss.hFull,
                    dibsCss.border,
                    dibsCss.borderSolid,
                    dibsCss.borderDolphin,
                    dibsCss.bgWhite,
                    dibsCss.sassyFontBodySmallHeavy,
                    dibsCss.textNoir
                )}
                onClick={onClick}
                target={target}
                linkData={{
                    path: href,
                    isLinkable: false,
                }}
                dataTn={dataTn || 'feed-carousel-view-all-tile'}
            >
                <PdpSharedFeedCarouselViewAllLabel />
            </SeoLink>
        </div>
    );
};
